query WfaSessionDetails($runId: ConditionID!) {
	wfa_session_runs(run_id_eq: $runId) {
		run_id
		session_name
		update_time
		run_time
		domain
		analysis_root_selector
		detection_types
		user_name
		custom_fields
	}
}
